import { Link } from 'react-router-dom'
import { Trans } from '@lingui/macro'
import { Button } from '../Buttons/Button/Button'
import { useCallback, useState } from 'react'
import { CookieConsentModal } from './CookieConsentModal'
import {
  hasConsentableCookies,
  useCookieDeclarations,
  useHasCookieConsentSupport,
} from './cookieConsent'
import { cn } from '@jotta/utils/css'

export function CookieLinks({ className }: { className?: string }) {
  const cookieConsentOpen = useState(false)
  const [_, setCookieConsentOpen] = cookieConsentOpen
  const openCookieConsent = useCallback(() => {
    setCookieConsentOpen(true)
  }, [setCookieConsentOpen])

  const hasCookieConsentSupport = useHasCookieConsentSupport()
  const cookieDeclarations = useCookieDeclarations()

  return (
    hasCookieConsentSupport && (
      <>
        <Link className={cn('link', className)} to="/cookies">
          <Trans>Cookie Policy</Trans>
        </Link>

        {hasConsentableCookies(cookieDeclarations) && (
          <>
            <CookieConsentModal openState={cookieConsentOpen} />
            <Button
              className={cn('btn btn-link', className)}
              onClick={openCookieConsent}
            >
              <Trans>Cookie Settings</Trans>
            </Button>
          </>
        )}
      </>
    )
  )
}
